import React from "react";
import { array, elementType, string } from "prop-types";

import FeaturedContentItems from "../../../components/FeaturedContentBlock/FeaturedContentItems";
import SectionResourcesGraphpad from "./brand/Graphpad";
import SectionResourcesDefault from "./brand/Default";
import { BRAND_CODE_GP, BRAND_CODE_LA, BRAND_CODE_OM } from "../../../../constants";

const SectionResources = ({ id, title, brandCode, Component = null, items = [], ...props }) => {
	const SectionComponent = brand => {
		switch (brand.toLowerCase()) {
			case BRAND_CODE_GP:
				return SectionResourcesGraphpad;
			default:
				return SectionResourcesDefault;
		}
	};

	const itemsConfig = brand => {
		switch (brand.toLowerCase()) {
			case BRAND_CODE_OM:
				return { isImgFluid: true, withFilter: true };
			case BRAND_CODE_LA:
				return { isImgFluid: true, withFilter: false };
			default:
				return { isImgFluid: false, withFilter: false };
		}
	};

	const SectionBrand = SectionComponent(brandCode);

	return (
		<SectionBrand title={title} id={id} {...props}>
			<FeaturedContentItems items={items} {...itemsConfig(brandCode)} />
			{Component ? <Component /> : null}
		</SectionBrand>
	);
};

SectionResources.propTypes = {
	brandCode: string,
	id: string.isRequired,
	title: string,
	Component: elementType,
	items: array, // eslint-disable-line react/forbid-prop-types
};

export default SectionResources;
